import * as React from "react"
import { Box, Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { DATE_METRICS } from "@constants"

import { DataCell } from "./DataCell"

export default function dataColumn(name, monitoringTableMetric, monitoringTableSites, monitoringTableFilledData=false, showVariants=false) {
    return {
        name: 'data',
        label: monitoringTableMetric === DATE_METRICS.HOURLY ?
            name.date :
            (monitoringTableMetric === 'date' ? formatDate(name.date, { isString: true }) : name.dateFormatted),
        options: {
            filter: false,
            sort: false,
            headerAlign: 'center',
            setCellProps: () => ({ sx: { borderRight: '1px solid', borderColor: "divider" } }),
            customHeadLabelRender: () => {
                if (monitoringTableMetric === DATE_METRICS.HOURLY) {
                    return <Box>
                        <Box minHeight={17}>
                            {name.isFirst && (
                                <Typography variant="caption" sx={{ display: 'block', fontSize: '0.7rem' }}>
                                    {formatDate(name.day, { isString: true })}
                                </Typography>
                            )}
                        </Box>
                        <Typography  variant="subtitle2">
                            {name.date}
                        </Typography>
                    </Box>
                }

                return (
                    <Typography variant="subtitle2">
                        {monitoringTableMetric === 'date' ? formatDate(name.date, { isString: true }) : name.dateFormatted}
                    </Typography>
                )
            },
            customBodyRowRenderLite: (_, { rowPrices, haveMainPrice }) => {
                return <Box>
                    {monitoringTableSites?.map(siteID =>
                        <DataCell
                            key={siteID}
                            siteID={siteID}
                            rowPrices={rowPrices}
                            date={name.dateKey}
                            metric={monitoringTableMetric}
                            haveMainPrice={haveMainPrice}
                            filledData={monitoringTableFilledData}
                            showVariants={showVariants}
                        />
                    )}
                </Box>
            }
        }
    }
}